import { render, staticRenderFns } from "./year-popup.vue?vue&type=template&id=15ad32fc&scoped=true&"
import script from "./year-popup.vue?vue&type=script&lang=ts&"
export * from "./year-popup.vue?vue&type=script&lang=ts&"
import style0 from "./year-popup.vue?vue&type=style&index=0&id=15ad32fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad32fc",
  null
  
)

export default component.exports